export enum FrequencyTypesEnum {
    MONTHLY = 'monthly',
    WEEKLY = 'weekly',
    DAILY = 'daily',
}
